const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  teacherToken: state => state.teacher.teacherToken,
  teacherAvatar: state => state.teacher.teacherAvatar,
  teacherName: state => state.teacher.teacherName,
  mobileToken: state => state.mobile.mobileToken,
  mobileAvatar: state => state.mobile.mobileAvatar,
  mobileName: state => state.mobile.mobileName
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js